<template>
    <div>
        <!-- Modal -->
        <div id="projectManagementBehaviorModal" class="modal fade" role="dialog">
            <div class="modal-dialog" :class="editing ? 'modal-lg' :''">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">
                            {{ form.id ? 'Edit Project Management Behavior' : 'New Project Management Behavior' }}
                        </h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="form.errors.clear($event.target.name)">
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="name"
                                       :class="{'text-red': form.errors.has('name')}">Name</label>
                                <input v-model="form.name" id="name" name="name" dusk="project-management-name"
                                       class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                       :class="{'border-red': form.errors.has('name')}">
                                <div class="text-red text-xs" v-if="form.errors.has('name')"
                                     dusk="project-management-name-error">
                                    {{ form.errors.get('name') }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="value"
                                       :class="{'text-red': form.errors.has('value')}">Value</label>
                                <input v-model="form.value" id="value" name="value" type="number" dusk="project-management-value"
                                       @input="form.errors.clear('value')"
                                       class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                       :class="{'border-red': form.errors.has('value')}">
                                <div class="text-red text-xs" v-if="form.errors.has('value')"
                                     dusk="project-management-value-error">{{
                                        form.errors.get('value') }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="assigned_to"
                                       :class="{'text-red': form.errors.has('assigned_to')}">Assigned To</label>
                                <select v-model="form.assigned_to" id="assigned_to" name="assigned_to"
                                        dusk="project-management-assigned-to"
                                        @input="form.errors.clear('assigned_to')"
                                        class="bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                        :class="{'border-red': form.errors.has('assigned_to')}">
                                    <option v-for="item in projectManagementPersons" :key="item.column"
                                            :value="item.column">{{ item.name }}
                                    </option>
                                </select>
                                <div class="text-red text-xs" v-if="form.errors.has('assigned_to')"
                                     dusk="project-management-assigned-to-error">{{
                                        form.errors.get('assigned_to')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="assigned_to"
                                       :class="{'text-red': form.errors.has('contract_type_id')}">Contract Type</label>
                                <select v-model="form.contract_type_id" id="contract_type" name="contract_type_id"
                                        dusk="project-management-contract-type-id"
                                        @input="form.errors.clear('contract_type_id')"
                                        class="bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                        :class="{'border-red': form.errors.has('contract_type_id')}">
                                    <option :value="null"></option>
                                    <option v-for="item in projectContractTypes" :key="item.id"
                                            :value="item.id">{{ item.code }}
                                    </option>
                                </select>
                                <div class="text-red text-xs" v-if="form.errors.has('contract_type_id')"
                                     dusk="project-management-contract-type-id-error">{{
                                        form.errors.get('contract_type_id')
                                    }}
                                </div>
                            </div>
                            <hr v-if="projectDurations.length && !parsing_durations">
                            <div class="row m-0" v-if="projectDurations && !parsing_durations && editing">
                                <div class="col-md-8 pl-0">
                                    <label class="text-md text-grey-darkest mb-4" for="project_durations">Date
                                        Defaults - Day from start</label>
                                </div>
                                <div class="col-md-4">
                                    <label class="text-md text-grey-darkest mb-4">Days from previous behavior</label>
                                </div>
                                <div class="mb-2 col-md-12  p-0" v-for="item in projectDurations" :key="item.id">
                                    <label class="text-sm text-grey-darkest mb-0 col-md-12 p-0" :for="item.code"
                                           :class="{'text-red': form.errors.has('project_durations.' + item.id + '.days')}">{{
                                            item.full_description
                                        }}</label>
                                    <div class="row m-0">
                                        <div class="col-md-8 pl-0">
                                            <input v-model="form.project_durations[item.id].days" :id="item.code"
                                                   :name="item.code" type="number"
                                                   :dusk="'project-management-duration-' + item.id"
                                                   @input="form.errors.clear('project_durations'); updateDurationDifference(item);"
                                                   class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                                   :class="{'border-red': form.errors.has('project_durations.' + item.id + '.days')}">
                                            <div class="text-red text-xs"
                                                 v-if="form.errors.has('project_durations.' + item.id + '.days')"
                                                 :dusk="'project-management-duration-' + item.id + '-error'">{{
                                                    form.errors.get('project_durations.' + item.id + '.days')
                                                }}
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <input :id="'previous-'+item.code"
                                                   :name="'days-difference-'+item.code" type="number"
                                                   v-model="form.project_durations[item.id].difference"
                                                   disabled="disabled"
                                                   class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="projectDurations && !parsing_durations && !editing">
                                <label class="text-md text-grey-darkest mb-4" for="project_durations">Date
                                    Defaults</label>
                                <div class="mb-2" v-for="item in projectDurations" :key="item.id">
                                    <label class="text-sm text-grey-darkest -mb-0" :for="item.code"
                                           :class="{'text-red': form.errors.has('project_durations.' + item.id + '.days')}">{{
                                        item.full_description
                                        }}</label>
                                    <input v-model="form.project_durations[item.id].days" :id="item.code"
                                           :name="item.code" type="number"
                                           :dusk="'project-management-duration-' + item.id"
                                           @input="form.errors.clear('project_durations')"
                                           class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                           :class="{'border-red': form.errors.has('project_durations.' + item.id + '.days')}">
                                    <div class="text-red text-xs"
                                         v-if="form.errors.has('project_durations.' + item.id + '.days')"
                                         :dusk="'project-management-duration-' + item.id + '-error'">{{
                                        form.errors.get('project_durations.' + item.id + '.days')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <hr v-if="projectDurations.length && !parsing_durations">
                            <div>
                                <label class="text-sm text-grey-darkest -mb-0" for="load_order"
                                       :class="{'text-red': form.errors.has('load_order')}">Load Order</label>
                                <input v-model="form.load_order" type="number" name="load_order" id="load_order"
                                       dusk="project-management-load-order"
                                       @input="form.errors.clear('load_order')"
                                       class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                       :class="{'border-red': form.errors.has('load_order')}">
                                <div class="text-red text-xs" v-if="form.errors.has('load_order')"
                                     dusk="project-management-load-order-error">
                                    {{ form.errors.get('load_order') }}
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer" style="display: block !important;">
                        <div class="form-group form-check pl-0 mb-1 float-left">
                            <input
                                type="checkbox"
                                v-model="form.unlock_activity"
                            >
                            <label class="form-check-label">
                                Unlock activity - can be completed multiple times
                            </label>
                        </div>
                        <button @click.prevent="saved" dusk="project-management-save"
                                class="bg-followup-nav float-right hover:bg-followup-nav-darker p-2 rounded text-white focus:outline-none">
                            Save
                        </button>

                    </div>
                </div>

            </div>
        </div>

        <div class="flex justify-center my-3" v-if="loading || parsing_durations" dusk="project-management-second-load">
            <i class="fa  fa-2x fa-spinner fa-spin text-teal"></i>
        </div>

        <div v-if="!noStages && !noDurations">
            <div v-if="!loading && !parsing_durations && filtered.length > 0" class="text-grey-darkest">
                <div class="text-right">
                    <button data-toggle="modal" data-target="#projectManagementBehaviorModal"
                            dusk="project-management-add"
                            class="border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:no-underline hover:text-white material-icons p-1 rounded-full text-base text-followup-nav">
                        add
                    </button>
                </div>

                <div class="bg-white shadow-md rounded mb-6 mt-2" v-if="!loading">
                    <table class="text-left w-full border-collapse">
                        <thead>
                        <tr>
                            <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                                Name
                            </th>
                            <!--                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">-->
                            <!--                            Value-->
                            <!--                        </th>-->
                            <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                                Contract Type
                            </th>
                            <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                                Assigned To
                            </th>
                            <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light text-center">
                                Load Order
                            </th>
                            <th class="py-2 pl-4 pr-4 bg-grey-lightest border-b border-grey-light"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr @click="editBehavior(item)" :key="item.id" class="hover:bg-grey-lighter cursor-pointer"
                            v-for="item in filtered"
                            v-if="!projectContractTypeId || projectContractTypeId == item.contract_type_id"
                            :dusk="'project-management-' + item.id">
                            <td class="pl-4 py-2 border-b border-grey-light text-xs">
                                {{ item.name }}
                            </td>
                            <!--                        <td class="pl-4 py-2 border-b border-grey-light text-xs">-->
                            <!--                            {{ item.value }}-->
                            <!--                        </td>-->
                            <td class="pl-4 py-2 border-b border-grey-light text-xs">
                                {{ item.contract_type ? item.contract_type.code : '' }}
                            </td>
                            <td class="pl-4 py-2 border-b border-grey-light text-xs">
                                {{ item.assigned_to | assignedToName }}
                            </td>
                            <td class="pl-4 py-2 border-b border-grey-light text-xs text-center">
                                {{ item.load_order }}
                            </td>
                            <td class="px-4 py-2 border-b border-grey-light">
                                <button @click.stop="editBehavior(item)"
                                        class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">
                                    edit
                                </button>
                                <button @click.stop="deleteCode(item)" v-if="!item.locked"
                                        :dusk="'project-management-delete-' + item.id"
                                        class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">
                                    delete
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div v-if="!loading && !parsing_durations" class="mt-10 text-center">
            <div class="flex-col">
                <div>
                    <img width="400" src="/images/blank.svg">
                </div>
                <div v-if="noStages" class="mt-4">
                    <div class="text-lg text-grey-darkest mb-2 flex justify-center">
                        <div class="text-xl w-1/4 tracking-wide">You can't create a behavior without project stages! Add
                            a code first.
                        </div>
                    </div>
                </div>

                <div v-if="noDurations" class="mt-4">
                    <div class="text-lg text-grey-darkest mb-2 flex justify-center">
                        <div class="text-xl w-1/4 tracking-wide">You can't create a behavior without project durations!
                            Add
                            a code first.
                        </div>
                    </div>
                </div>
                <div v-if="!noStages && !noDurations && filtered.length === 0" class="mt-4">
                    <div class="text-lg text-grey-darkest mb-2 flex justify-center">
                        <div class="text-xl w-1/4 tracking-wide">You haven't created a behavior yet!</div>
                    </div>
                    <button @click="addBehavior" dusk="project-management-add-first"
                            class="bg-followup-nav px-4 py-2 rounded-full text-white focus:outline-none hover:bg-followup-nav-darker text-xl">
                        Click here to add your first {{ projectStageName ? projectStageName.toLowerCase() : '' }}
                        behavior!
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Form from "../../../utils/form";

export default {
    name : 'project-management-behaviors-table',
    props: ['project-durations', 'project-stage-id', 'project-contract-type-id', 'project-contract-types', 'project-stage-name', 'no-stages', 'no-durations', 'project-stages'],

    data() {
        return {
            editing                 : false,
            loading                 : true,
            parsing_durations       : true,
            current                 : null,
            form                    : new Form({
                project_stage_id : this.projectStageId,
                contract_type_id : this.projectContractTypeId,
                contract_types   : this.projectContractTypes,
                name             : '',
                value            : '',
                assigned_to      : '',
                load_order       : '',
                unlock_activity   : 0,
                project_durations: {}
            }),
            behaviors               : [],
            filtered                : [],
            projectManagementPersons: [
                {
                    column: 'project_manager_id',
                    name  : 'Project Manager'
                },
                {
                    column: 'project_engineer_id',
                    name  : 'Project Engineer'
                },
                {
                    column: 'project_admin_id',
                    name  : 'Project Admin'
                },
                {
                    column: 'superintendent_id',
                    name  : 'Superintendent'
                },
                {
                    column: 'crew_leader_id',
                    name  : 'Crew Leader'
                }
            ]
        }
    },

    watch: {
        behaviors() {
            this.filterBehaviors();
        },

        projectStageId() {
            this.form.project_stage_id = this.projectStageId;
            this.filterBehaviors();
        },

        projectContractTypeId() {
            this.form.contract_type_id = this.projectContractTypeId;
            this.fetchData();
            this.filterBehaviors();
        },

        projectDurations() {
            this.parseProjectDurations();
        }
    },

    filters: {
        assignedToName: value => {
            switch (value) {
                case 'project_manager_id':
                    return 'Project Manager';
                case 'project_engineer_id':
                    return 'Project Engineer';
                case 'project_admin_id':
                    return 'Project Admin';
                case 'superintendent_id':
                    return 'Superintendent';
                case 'crew_leader_id':
                    return 'Crew Leader';
            }
        }
    },

    mounted() {
        let self = this;
        this.fetchData();
        this.parseProjectDurations();
        $("#projectManagementBehaviorModal").on('hidden.bs.modal', function () {
            self.resetForm();
            self.editing = false;
            self.current = null;
        });
    },

    methods: {
        fetchData() {
            axios.get(route('project-management.api.settings.project-management-behavior.index')).then(({data}) => {
                this.behaviors = _.filter(data, item => item.contract_type_id === this.form.contract_type_id);
                let sortedBehaviors = [];
                _.map(this.projectStages, stage => {
                    let currentStageBehaviors = _.filter(this.behaviors, item => item.project_stage_id === stage.id);
                    currentStageBehaviors = _.orderBy(currentStageBehaviors, ['load_order'],['asc']);
                    sortedBehaviors = sortedBehaviors.concat(currentStageBehaviors);
                    return true;
                })

                this.behaviors = sortedBehaviors;
                this.loading   = false;
            })
        },

        resetForm() {
            this.parsing_durations = true;

            this.form.reset();

            this.parseProjectDurations();
            this.form.project_stage_id = this.projectStageId;
            this.form.contract_type_id = this.projectContractTypeId;
            this.form.contract_types   = this.projectContractTypes;
            this.form.unlock_activity   = 0;
        },

        parseProjectDurations() {
            this.form.project_durations = {};
            this.projectDurations.forEach(item => {
                this.form.project_durations[item.id] = {days: null}
            });
            this.parsing_durations = false;
        },

        saved() {
            let self = this;
            if (this.editing) {
                this.form.put(route('project-management.api.settings.project-management-behavior.update', this.current.id)).then(() => {
                    $("#projectManagementBehaviorModal").modal("hide");
                    this.fetchData();
                });
            } else {
                this.form.post(route('project-management.api.settings.project-management-behavior.store')).then(() => {
                    $("#projectManagementBehaviorModal").modal("hide");
                    this.fetchData();
                });
            }
        },

        addBehavior() {
            $("#projectManagementBehaviorModal").modal("show");
        },

        async editBehavior(item) {
            $("#projectManagementBehaviorModal").modal("show");
            this.current = item;
            this.editing = true;
            this.parseForm(item);
        },

        parseForm(behavior) {
            let data = {
                ...behavior,
                project_durations: {}
            }

            _.forEach(behavior.project_durations, item => {
                data.project_durations[item.id] = {days: item.pivot.days, difference: this.calculateDaysFromPrevious(item) }
            });

            Object.assign(this.form, data);
        },

        deleteCode(item) {
            let self = this;
            Swal.fire({
                title             : "Are you sure?",
                text              : "Once deleted, you will not be able to recover this behavior!",
                icon              : "warning",
                buttons           : true,
                dangerMode        : true,
                showCancelButton  : true,
                confirmButtonColor: '#17252A',
                confirmButtonText : 'I\'m sure!',
                closeOnConfirm    : true,
                closeOnCancel     : true,
            }).then((result) => {
                if (result.value) {
                    self.form.delete(route('project-management.api.settings.project-management-behavior.destroy', item.id)).then(() => {
                        this.fetchData();
                    });
                }
            });
        },

        filterBehaviors() {
            if (this.behaviors) {
                this.filtered = _.filter(this.behaviors, item => item.project_stage_id === this.projectStageId);
            }
        },

        updateDurationDifference(duration){




            this.form.project_durations[duration.id].difference = this.calculateDaysFromPrevious(duration, this.form.project_durations[duration.id].days);
        },
        calculateDaysFromPrevious(duration, days = null) {
            if(this.current){
                let currentIndex = _.findIndex(this.behaviors, (item) => { return item.id === this.current.id });

                let difference = 0;
                if(currentIndex > 0) {
                    const previous = this.behaviors[currentIndex-1]

                    const previousDuration = _.find(previous.project_durations, d => d.id === duration.id)
                    const currentDuration = _.find(this.current.project_durations, d => d.id === duration.id)

                    if(days) {
                        difference = days - previousDuration.pivot.days;

                    }else{
                        difference = currentDuration.pivot.days - previousDuration.pivot.days;
                    }
                }
                return difference;
            }
        }
    }
}
</script>
